
export enum CreditCardProcessorTypeEnum {
    PAYMENTECH = 'PAYMENTECH',
    MONERIS = 'MONERIS',
    PAYPAL = 'PAYPAL',
    EXACT = 'EXACT',
    STRIPE = 'STRIPE',
    PAYSAFE = 'PAYSAFE',
    DO_NOT_USE = 'DO_NOT_USE',
    CARDCONNECT = 'CARDCONNECT',
    GLOBALPAYMENTS='GLOBALPAYMENTS'
}
